import * as H from 'history';
import  React from 'react';
import { ISupportSpinner } from '../shared/Ajax';
import { LoginController } from '../controllers/LoginController';
import queryString from 'query-string';


export interface LogoutPageProps {
    history: H.History
    location: H.Location
}

export interface LogoutPageState {
    logoutInProgress: boolean
}

export class LogoutPage extends React.Component<LogoutPageProps, LogoutPageState> implements ISupportSpinner {
    ajax: LoginController

    constructor(props: LogoutPageProps) {
        super(props);

        this.ajax = new LoginController();

        this.state = {
            logoutInProgress: false
        }
    }

    componentDidMount() {
        this.ajax.logout(this, (d) => {
            if (d) {
                window.location.assign(d);
            }            
        });
    }

    toggleSpinner(on: boolean, callback: { (): any }) {
        this.setState({ logoutInProgress: on }, callback);
    }

    render() {
        return <div></div>
    }
}